import React from "react";

export default function Timer(time?: number) {
  return new Promise((resolve) => {
    setTimeout(
      () => {
        resolve("resolves");
      },
      time ? time : 500
    );
  });
}
